import { FormLabel } from 'components/Create/FormItems/FormLabel';

interface Props {
  text: string;
}

/**
 * A table column heading carrying the same required marker a required form label uses, so a required
 * column in a table reads the same way the rest of the request form does. Added for MDSI1-4304, where
 * the Return Part Number and Return Serial Number columns become required for defective returns.
 */
export const RequiredColumnTitle = ({ text }: Props): JSX.Element => <FormLabel label={text} required />;
